import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutPrimeLaundry from "./sections/AboutPrimeLaundry";
import OperationalApproach from "./sections/OperationalApproach";
import TheConcept from "./sections/TheConcept";
import PlannedLocation from "./sections/PlannedLocation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutPrimeLaundry />
      <OperationalApproach />
      <TheConcept />
      <PlannedLocation />
      <Footer />
    </div>;
}